/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./asset-view.vue?vue&type=template&id=5bc3e537&scoped=true&"
import script from "./asset-view.vue?vue&type=script&lang=ts&"
export * from "./asset-view.vue?vue&type=script&lang=ts&"
import style0 from "./asset-view.vue?vue&type=style&index=0&id=5bc3e537&prod&scoped=true&lang=scss&"
import style1 from "./asset-view.vue?vue&type=style&index=1&id=5bc3e537&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc3e537",
  null
  
)

export default component.exports